module.exports = __webpack_public_path__ + "img/ttf.8cd460ca.svg";